import { PubIdentTyp } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('PubIdentTyp')

export default {
  label: 'PubIdentTyp',
  route: 'pubIdentTyp',
  class: PubIdentTyp,
  className: 'pubIdentTyp',
  fields: [
    {
      ...Fields.String('kennung'),
      table: true
    },
    Fields.String('anmerkung')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/PubIdentTyp.js